import React, { useState } from "react";
import EventDialog from "./EventDialog";

import { getDaysInMonth, startOfMonth, addDays } from "date-fns";
import CalendarCell from "./CalendarCell";

export default function CalendarGrid({
  startDate,
  period,
  openDialog,
  schedules,
  openModifyDialog,

  showInsight, // ! => Showing Insight
  displayDay, // ! => Showing Date

  simple,
  locationID,
  getSchedules,
  timeoff,
  location, // ! Only in Locations
  userID, // ! Only in Locations

  dayEvents, //! Display for dayevents
  getDayEvents,
}) {
  const [date, setDate] = useState(new Date());

  const startOfPeriod = startDate;
  const numDays = period;

  const getDays = () => {
    // console.log("Start Date: ", startDate);

    const days = [];
    let currentDate = startOfPeriod;

    for (let i = 0; i < numDays; i++) {
      days.push(currentDate);
      currentDate = addDays(currentDate, 1);
    }

    return days;
  };

  const openEventDialog = (date, locationID, userID) => {
    openDialog(date, locationID, userID);
  };

  const days = getDays();
  const pad = (n) => n.toString().padStart(2, "0");

  const getLocalYMD = (date) => {
    const yyyy = date.getFullYear();
    const mm = pad(date.getMonth() + 1); // Months are 0-based
    const dd = pad(date.getDate());
    return `${yyyy}-${mm}-${dd}`;
  };

  const convertLocalTimeToUTC = (date) => {
    const utcDate = new Date(
      Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
    );

    return utcDate;
  };

  const timeFormat = (timeStr) => {
    const time = new Date(timeStr);
    time.setFullYear(time.getUTCFullYear());
    time.setMonth(time.getUTCMonth());
    time.setDate(time.getUTCDate());
    time.setHours(time.getUTCHours());
    time.setMinutes(time.getUTCMinutes());
    time.setSeconds(time.getUTCSeconds());
    return time;
  };
  return (
    <>
      {days.map((dd, idx) => {
        const dayStr = getLocalYMD(dd); // Ensure dd is in 'yyyy-mm-dd'

        // console.log(dd);
        // console.log(dayStr);

        // Find the schedules for the current day
        const daySchedules = schedules.filter((schedule) => {
          const scheduleDate = schedule.startTime.split("T")[0];

          return scheduleDate === dayStr;
        });

        // console.log(dd);
        // console.log(timeFormat(dd));
        // console.log(convertLocalTimeToUTC(dd));
        // console.log("-------------");

        // If no schedules exist for this day, return null
        if (daySchedules.length === 0) {
          if (displayDay) {
            return (
              <CalendarCell
                period={period}
                dayEvents={dayEvents}
                getDayEvents={getDayEvents}
                date={convertLocalTimeToUTC(dd)}
                displayDay={displayDay}
              />
            );
          } else if (showInsight) {
            return (
              <CalendarCell
                period={period}
                date={convertLocalTimeToUTC(dd)}
                schedules={schedules}
                showInsight={showInsight}
              />
            );
          } else {
            return (
              <CalendarCell
                getSchedules={getSchedules}
                simple={simple}
                period={period}
                empty={true}
                locationID={locationID}
                openDialog={(date, locationID, userID) =>
                  openEventDialog(date, locationID, userID)
                }
                date={convertLocalTimeToUTC(dd)}
                timeoff={timeoff}
                location={location} // ! Only in Locations
                userID={userID} // ! Only in Locations
              />
            );
          }
        }

        // If there are schedules, map through them and render CalendarCell for each
        if (displayDay) {
          return (
            <CalendarCell
              period={period}
              dayEvents={dayEvents}
              getDayEvents={getDayEvents}
              date={convertLocalTimeToUTC(dd)}
              displayDay={displayDay}
            />
          );
        } else if (showInsight) {
          return (
            <CalendarCell
              period={period}
              schedules={schedules}
              date={convertLocalTimeToUTC(dd)}
              showInsight={showInsight}
            />
          );
        } else {
          return (
            <CalendarCell
              simple={simple}
              getSchedules={getSchedules}
              period={period}
              locationID={locationID}
              openModifyDialog={openModifyDialog}
              key={idx}
              empty={false}
              timeoff={timeoff}
              entries={daySchedules}
              openDialog={(date, locationID, userID) =>
                openEventDialog(date, locationID, userID)
              }
              date={convertLocalTimeToUTC(dd)}
              location={location} // ! Only in Locations
              userID={userID} // ! Only in Locations
            />
          );
        }
      })}
    </>
  );
}
